import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { DailyPluckingAverageAnalysisRegisteredReport } from './Pages/listing';

export const DailyPluckingAverageAnalysisRegisteredReportRoutes = ({ match }) => (
    <Fragment>
        <Route exact path={`${match.path}`} component={DailyPluckingAverageAnalysisRegisteredReport} />
    </Fragment>
)